import React from 'react';

import { batch } from 'react-redux';

import { PreQualificationStep, setPreQualificationStep } from 'actions';
import { clearBorrowerExceptSpecificProperties } from 'actions/borrower';
import { clearCoBorrower } from 'actions/coBorrower';
import { clearIncome } from 'actions/income';
import { clearPrequalificationPortal } from 'actions/prequalificationPortal';
import { Button } from 'components/Buttons/Button';
import FormHeader from 'components/FormHeader';
import { ButtonType } from 'enums/ButtonType';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { Theme } from 'enums/Theme';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'hooks/useAppSelector';
import { AppRoutes } from 'routes/routes.enums';

import styles from './NoActiveApplication.module.scss';

const FORM_HEADER_TITLE = 'Welcome back to your HFS Loan Portal';
const FORM_HEADER_SUBTITLE = 'Your prior application is no longer active. Please, submit a new application below.';

const NoActiveApplication = () => {
  const dispatch = useAppDispatch();
  const navigator = useAppNavigate();
  const { email } = useAppSelector((state) => state.borrower);
  const handleStartNewApplicationClick = () => {
    batch(() => {
      dispatch(clearPrequalificationPortal());
      dispatch(clearBorrowerExceptSpecificProperties({ email }));
      dispatch(clearCoBorrower());
      dispatch(clearIncome());

      dispatch(setPreQualificationStep(PreQualificationStep.LoanAmount));
      navigator(AppRoutes.Prequalification);
    });
  };

  return (
    <div>
      <FormHeader
        title={FORM_HEADER_TITLE}
        subtitle={FORM_HEADER_SUBTITLE}
        theme={Theme.Dark}
        isBorderRounded
        percent={ProgressBarStatus.Failed}
      />
      <Button
        buttonType={ButtonType.Primary}
        onClick={handleStartNewApplicationClick}
        className={styles.startNewApplicationButton}
      >
        Start New Application
      </Button>
    </div>
  );
};

export default NoActiveApplication;
